import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-[#F7F7F7]',
    container:
      'relative mx-auto max-w-[1366px] overflow-hidden lg:h-[732px] lg:px-10 lg:pt-30',
    woman: 'relative lg:w-[56%]',
    womanImage: 'block w-full object-cover',
    logoRecommend: 'absolute top-[68px] right-3.5 w-[150px] lg:hidden',
    hoursMobile:
      'absolute right-4 bottom-11 text-[72px] leading-[1.5] font-medium text-white lg:hidden',
    hoursMobileUnit: 'max-md:text-[52px] max-md:font-bold',
    hoursMobileLabel:
      '-mt-4 block text-base leading-[1.2] font-medium text-white uppercase',
    technologyMobile:
      'absolute right-[-17px] -bottom-3.5 z-2 max-w-60 rounded-full bg-[#00BBDC] px-[18px] py-2 text-left text-[13px] leading-none font-bold text-white uppercase lg:hidden',
    titleDesktop:
      'hidden max-w-[350px] pt-10 pl-10 font-bold text-[#003A70] uppercase lg:block',
    titleBig: 'mb-1 block text-[40px] leading-[1.1]',
    titleSmall: 'block text-base leading-[1.1]',
    titleMobile:
      'absolute bottom-16 left-[150px] z-2 max-w-40 font-bold text-[#003A70] uppercase md:right-[311px] md:left-auto lg:hidden',
    titleBigMobile: 'mb-2 block text-[28px] leading-[1.1]',
    titleSmallMobile: 'block text-base leading-[1.2]',
    products:
      'absolute -bottom-[7px] -left-[15px] z-2 w-[174px] md:left-0 md:w-[300px] lg:bottom-[-4px] lg:left-1/2 lg:w-[24.4%] lg:-translate-x-1/2',
    productsImage:
      'block w-full md:h-[495px] md:w-[300px] lg:h-auto lg:w-[272px]',
    info: 'relative h-[198px] lg:absolute lg:top-[182px] lg:right-10 lg:h-auto lg:w-[45.6%]',
    videoWrap: 'relative hidden lg:block',
    video: 'block h-[300px] w-full object-cover',
    videoText:
      'absolute top-[101px] right-[10%] w-[330px] text-center text-xl leading-[1.2] font-medium text-white uppercase xl:right-[17%] xl:text-2xl',
    videoLogo: 'absolute right-[15%] bottom-12 w-[251px] xl:right-[23%]',
    technology:
      'absolute right-[72px] -bottom-5 hidden max-w-80 rounded-[40px] bg-[#00BBDC] px-4 pt-[10px] pb-2 text-center text-sm leading-none font-bold text-white uppercase lg:block xl:right-[114px] xl:text-[15px]',
    hours:
      'absolute right-[35%] -bottom-[179px] hidden text-[#003A70] lg:block xl:right-[31%]',
    hoursBig: 'block text-[76px] leading-[1.5] font-medium xl:text-[96px]',
    hoursSmall:
      '-mt-6 block text-base leading-[1.5] font-bold uppercase xl:text-xl',
    circle:
      'pointer-events-none absolute -top-[106px] -left-[330px] hidden w-[517px] max-w-none lg:block'
  }
});
